import React                        from 'react';
import { Observe }                  from 'rewire-core';
import {
  WithStyle,
  FormView,
  Modal
}                                   from 'rewire-ui';
import { Theme }                    from '@material-ui/core/styles';
import DraggableResizableDialog2    from '../ui/DraggableResizableDialog2';
import TitleWithFlowLogo            from '../ui/TitleWithFlowLogo';
import userProfileDialogModel       from './UserProfileDialogModel';
import { withStyles }               from '../utility/styles';
import { isNullOrUndefinedOrEmpty } from 'rewire-common';

const styles = (theme: Theme) => ({
  contentContainer: {
    paddingRight: '250px',
  },
  avatarFieldContainer: {
    position: 'absolute',
    marginTop: '20px',
    right: '20px',
  },
  avatarRoot: {
    fontSize: '56px',
  },
  avatarColorDefault: {
    backgroundColor: theme.palette.dialogPrimary.light,
  },
});

interface IUserProfileDialogProps {
}

type UserProfileDialogProps = WithStyle<ReturnType<typeof styles>, IUserProfileDialogProps>;

class UserProfileDialog extends React.PureComponent<UserProfileDialogProps> {
  constructor(props: UserProfileDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    userProfileDialogModel.reset();
  }

  getTitle = (_dialog: Modal): JSX.Element => {
    return <TitleWithFlowLogo beforeText='My' afterText='Profile' />;
  };

  renderDialogContents = React.memo((): JSX.Element => {
    const {classes} = this.props;

    return <Observe render={() => (
      <FormView form={userProfileDialogModel.form} onSubmit={userProfileDialogModel.actionFn('save')}>
        <div className={classes.contentContainer}>
          <div className='content'>
            <userProfileDialogModel.form.field.name.Editor className='span1' />
          </div>
          <div className='content'>
            <userProfileDialogModel.form.field.phone.Editor className='span1' />
          </div>
          <div className='content'>
            <userProfileDialogModel.form.field.email.Editor className='span1' />
          </div>
          <div className='content'>
            <userProfileDialogModel.form.field.organization.Editor className='span1' />
          </div>
          <div className='content'>
            <userProfileDialogModel.form.field.location.Editor className='span1' />
          </div>
          <div className='content'>
            <userProfileDialogModel.form.field.role.Editor className='span1' />
          </div>
        </div>
        <div className={classes.avatarFieldContainer}>
          <userProfileDialogModel.form.field.avatar.Editor
            avatarClasses={{root: classes.avatarRoot, colorDefault: classes.avatarColorDefault}}
            avatarChildren={!isNullOrUndefinedOrEmpty(userProfileDialogModel.userInitials)
              ? userProfileDialogModel.userInitials
              : null
            }
          />
        </div>
      </FormView>
    )} />;
  });

  render() {
    return  <Observe render={() => (
      <DraggableResizableDialog2 defaultWidth='sm' DialogProps={{dialog: userProfileDialogModel, disableEscapeKeyDown: false, title: this.getTitle}} DraggableResizableBoxProps={{minWidth: '480px', minHeight: '454px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog2>
    )} />;
  }
}

export default withStyles<IUserProfileDialogProps>(styles, UserProfileDialog);
